module.exports = __webpack_public_path__ + "img/kdocs_logo.65896f78.svg";